import Calculator from "@/components/Calculator"
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import {Info} from 'lucide-react'

function AmethystCalculator() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-purple-50">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Amethyst Value Calculator
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Calculate amethyst carat weight and value. Get accurate price estimates for your amethyst gemstones.
          </p>
        </div>

        <div className="mb-12">
          <Calculator 
            defaultGemstone="amethyst"
            title="Amethyst Weight & Value Calculator"
            description="Specialized calculator for amethyst gemstones (SG: 2.65)"
          />
        </div>

        <div className="bg-white rounded-xl shadow-lg border border-purple-100 p-8">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <Info className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">About Amethyst Gemstones</h2>
              <p className="text-gray-600 mb-4">
                Amethyst is a purple variety of quartz and one of the most popular gemstones. With a specific gravity of 2.65, amethysts are relatively light. They range from pale lilac to deep purple and are February's birthstone.
              </p>
              <h3 className="font-bold text-gray-900 mb-2">Amethyst Value Factors:</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
                <li><strong>Color:</strong> Deep, rich purple with red flashes is most valuable</li>
                <li><strong>Clarity:</strong> Eye-clean stones are preferred</li>
                <li><strong>Size:</strong> Larger stones are more available than in other gems</li>
                <li><strong>Origin:</strong> Uruguayan and Brazilian amethysts are prized</li>
                <li><strong>Treatment:</strong> Natural color is most desirable</li>
              </ul>
              <p className="text-gray-600 mt-4">
                Use our amethyst calculator to determine the approximate worth and value of your amethyst gemstones based on weight and quality.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default AmethystCalculator
